import axiosInstance from "../axiosInstance";

export const historicalShipmentService = {
  fetch: async (query) => {
    try {
      let api_query = `/proxy-historical/shipments?`;

      if (query) {
        api_query += query;
      }

      const response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      console.error("Error fetching historical shipments:", error);
      throw error;
    }
  },

  filter: async (obj) => {
    try {
      const response = await axiosInstance.post(
        `/proxy-historical/shipments/advanced-filter`,
        obj
      );
      return response.data;
    } catch (error) {
      console.error("Error filtering historical shipments:", error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(
        `/proxy-historical/shipments/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchUniqueValues: async (client_id, field, search, limit = 15, skip = 0) => {
    try {
      let endpoint = `/proxy-historical/shipments/unique/${field}?`;

      if (client_id) {
        endpoint += `&client_id=${client_id}`;
      }
      if (search) {
        endpoint += `&search=${search}`;
      }

      const response = await axiosInstance.get(
        `${endpoint}&limit=${limit}&skip=${skip}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching unique values:", error);
      throw error;
    }
  },
};
